export const PROFILE_STATUS_STYLES = {
    draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
    onboarding: { label: "Onboarding", cls: "bg-blue-100 text-blue-700" },
    ai_processing: {
        label: "AI Processing",
        cls: "bg-indigo-100 text-indigo-700",
    },
    ai_completed: {
        label: "AI Completed",
        cls: "bg-teal-100 text-[#0F766E]",
    },
    admin_review: {
        label: "Admin Review",
        cls: "bg-orange-100 text-[#D97706]",
    },
    changes_requested: {
        label: "Changes Requested",
        cls: "bg-red-100 text-[#DC2626]",
    },
    admin_approved: {
        label: "Admin Approved",
        cls: "bg-green-100 text-[#15803D]",
    },
    doctor_review: {
        label: "Doctor Review",
        cls: "bg-orange-100 text-[#D97706]",
    },
    doctor_approved: {
        label: "Doctor Approved",
        cls: "bg-green-100 text-[#15803D]",
    },
    payment_pending: {
        label: "Payment Pending",
        cls: "bg-yellow-100 text-yellow-800",
    },
    ready_to_publish: {
        label: "Ready to Publish",
        cls: "bg-blue-100 text-[#123B5D]",
    },
    published: {
        label: "Published",
        cls: "bg-green-100 text-[#15803D] ring-1 ring-green-600",
    },
    suspended: { label: "Suspended", cls: "bg-red-100 text-[#DC2626]" },
    archived: { label: "Archived", cls: "bg-slate-200 text-slate-800" },
};

export const MODULE_ICON_TITLES = [
    { code: "A", name: "Professional Digital Identity" },
    { code: "B", name: "Brand Building" },
    { code: "C", name: "Patient Info Services" },
    { code: "D", name: "Educational Content" },
    { code: "E", name: "Social Media" },
    { code: "F", name: "Achievements" },
    { code: "G", name: "Reputation" },
    { code: "H", name: "AI Content Engine" },
    { code: "I", name: "Media & Gallery" },
    { code: "J", name: "Patient/Digital Services" },
    { code: "K", name: "Social Impact" },
    { code: "L", name: "Documents" },
    { code: "M", name: "Security & Data" },
    { code: "N", name: "Legacy" },
    { code: "O", name: "Continuous Service" },
];

export function inr(n) {
    if (n === null || n === undefined) return "—";
    return "₹" + Number(n).toLocaleString("en-IN");
}
